<template>
	<div>
		<div class="content">
			<div class="container help-center">
				<leftAbout></leftAbout>
				<div class="help-main">
					<h2>公司简介</h2>
					<div class="help-cont">
						<p v-html="HTMLDecode(settingPc.about)">

						</p>
						<ul class="list list-circle">
							<li v-for="(item,index) in cardList" :key="index">
								<h5 :class="item.class">
									{{item.name}}
									<small cite="text-dark">
										（
										<router-link class="link" :to="{path:'/shop?cateid='+item.cate_id}">前往{{item.name}}回收</router-link>
										 ）
									</small>
								</h5>

								<p>
									目前支持回收的卡有：{{item.str}},后期会逐步的发布更多的卡类回收。
								</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import leftAbout from '../common/about/index.vue'
	export default{
		name:"Me",
		data(){
			return{
				cardList:[],
        settingPc:{}
			}
		},
		components:{
			leftAbout
		},
		created(){
      this.settingPc = JSON.parse(localStorage.getItem('settingPc'))
      if(!this.settingPc){
        this.getSettings()
      }
			this.getCard()
		},
		methods:{
      HTMLDecode(text) {
      	var temp = document.createElement("div");
      	temp.innerHTML = text;
      	var output = temp.innerText || temp.textContent;
      	temp = null;
      	return output;
      },
      getSettings(){
        return new Promise((relove,reject) => {
          this.$api.systemsettings()
          .then(result => {
            this.settingPc = result
            localStorage.setItem('settingPc',JSON.stringify(result))
            this.$namePc = result.name
            relove(true)
          })
        })
      },
			getCard() {
				let token = localStorage.getItem('token')
					this.$api.getCardList({
							token:token
					}).then(res => {

							if(res.code === 1){
								let classList = ['text-red','text-pink','text-purple','text-blue','text-orange','text-green','text-choc','text-red']
								for(let i=0;i<res.data.length;i++){
									if(res.data[i].name === "积分兑"){
										res.data.splice(i,1)
										continue
									}
									let str = ''
									for(let j=0;j<res.data[i].card.length;j++){
										if(j+1 === res.data[i].card.length){
											str += res.data[i].card[j].goods_name
										}else{
											str += res.data[i].card[j].goods_name + '、'
										}
									}
									res.data[i].str = str
									res.data[i].class = classList[i]
								}
								this.cardList = res.data
							}
					})
				},
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/about/me.vue